module.exports = __webpack_public_path__ + "img/default-girl.032fa854.png";